export const SDK_VERSION = '7.72.0';
